import request from '@/utils/requests.js'

// Configurações de Unidade FHIR
export const fhirUnitConfigService = {
  // Listar todas as configurações de unidade
  async getAll() {
    return request({
      url: '/fhir/unit-configs',
      method: 'get'
    })
  },
  
  // Obter configuração específica
  async getById(id) {
    return request({
      url: `/fhir/unit-configs/${id}`,
      method: 'get'
    })
  },
  
  // Obter configuração padrão
  async getDefault() {
    return request({
      url: '/fhir/unit-configs/default',
      method: 'get'
    })
  },
  
  // Criar nova configuração
  async create(data) {
    return request({
      url: '/fhir/unit-configs',
      method: 'post',
      data
    })
  },
  
  // Atualizar configuração
  async update(id, data) {
    return request({
      url: `/fhir/unit-configs/${id}`,
      method: 'put',
      data
    })
  },
  
  // Excluir configuração
  async delete(id) {
    return request({
      url: `/fhir/unit-configs/${id}`,
      method: 'delete'
    })
  }
}

// Configurações de Profissionais FHIR
export const fhirProfessionalConfigService = {
  // Listar todas as configurações de profissionais
  async getAll() {
    return request({
      url: '/fhir/professional-configs',
      method: 'get'
    })
  },
  
  // Obter configuração por usuário
  async getByUserId(userId) {
    return request({
      url: `/fhir/professional-configs/user/${userId}`,
      method: 'get'
    })
  },
  
  // Criar/atualizar configuração de profissional
  async createOrUpdate(data) {
    return request({
      url: '/fhir/professional-configs',
      method: 'post',
      data
    })
  }
}

// Conversão FHIR
export const fhirConversionService = {
  // Converter exame para FHIR
  async convertExam(examId) {
    return request({
      url: `/fhir/convert/exam/${examId}`,
      method: 'post'
    })
  },
  
  // Converter estudo DICOM para FHIR
  async convertStudy(data) {
    return request({
      url: '/fhir/convert/study',
      method: 'post',
      data
    })
  },
  
  // Validar documento FHIR
  async validate(data) {
    return request({
      url: '/fhir/validate',
      method: 'post',
      data
    })
  }
}

// Submissão FHIR
export const fhirSubmissionService = {
  // Submeter para e-SUS
  async submitToESUS(data) {
    return request({
      url: '/fhir/submit/esus',
      method: 'post',
      data
    })
  },
  
  // Submeter para RNDS
  async submitToRNDS(data) {
    return request({
      url: '/fhir/submit/rnds',
      method: 'post',
      data
    })
  }
}

// Status do sistema FHIR
export const fhirSystemService = {
  // Verificar status do sistema FHIR
  async getStatus() {
    return request({
      url: '/fhir/system/status',
      method: 'get'
    })
  }
}

// Logs FHIR
export const fhirLogsService = {
  // Logs de conversão
  async getConversionLogs(params = {}) {
    return request({
      url: '/fhir/logs/conversion',
      method: 'get',
      params
    })
  },
  
  // Logs de submissão
  async getSubmissionLogs(params = {}) {
    return request({
      url: '/fhir/logs/submission',
      method: 'get',
      params
    })
  }
}

// Exportação XML e-SUS
export const fhirExportService = {
  // Exportar exame como XML e-SUS
  async exportESUSXML(examId) {
    return request({
      url: `/export/esus-xml/${examId}`,
      method: 'get',
      responseType: 'blob',
      headers: {
        'Accept': 'application/xml'
      }
    })
  },
  
  // Buscar exames para exportação
  async searchExamsForExport(params = {}) {
    return request({
      url: '/exams/',
      method: 'get',
      params: {
        ...params,
        include_patient: true,
        status: 'COMPLETED' // Apenas exames concluídos
      }
    })
  }
}

// Exportação padrão
export default {
  unitConfig: fhirUnitConfigService,
  professionalConfig: fhirProfessionalConfigService,
  conversion: fhirConversionService,
  submission: fhirSubmissionService,
  system: fhirSystemService,
  logs: fhirLogsService,
  export: fhirExportService
}
